import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import { ImageUploadStyle } from './Component.style';
import BasicIconButton from './BasicIconButton';

import { ReactComponent as UploadIcon } from 'assert/images/Jobs/upload.svg';
import { ReactComponent as Delete } from 'assert/images/More/delete.svg';
import { Notification } from './CustomNotification';

export default function UploadImagePreview({
  handleFileSRC,
  value,
  disabled,
  accept,
  onCloseFiles,
  label,
  required,
  multiple = false,
  imagepreview,
  isReplace,
  isDelete,
  maxFiles
}) {
  const [files, setFiles] = useState(value);
  const [enableFirstTime, setEnableFirstTime] = useState(true);

  const { getRootProps, getInputProps, isDragAccept, isDragReject } =
    useDropzone({
      maxFiles: maxFiles || 8,
      accept: accept || {
        'image/*': [],
      },
      disabled,
      multiple,
      onDrop: (acceptedFiles) => {
        if(acceptedFiles.find((li) => li.size / 1024 ** 2 > 8)) {
          Notification("warning", "Image size should not exceed 8 MB");
          return;
        }
        setFiles(
          acceptedFiles.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            })
          )
        );
      },
    });

  useEffect(() => {
    handleFileSRC(files);
    return () => [files || []].forEach((file) => URL.revokeObjectURL(file?.preview));
  }, [files]);

  useEffect(() => {
    if (value?.length && enableFirstTime) {
      setFiles(value);
      setEnableFirstTime(false);
    }
  }, [value]);

  const ImagePreviews = () => {
    return (
      <>
        <div className="previewImg">
          {files?.map((file, index) => (
            <>
              <img
                alt="preview"
                key={'file' + index}
                src={file?.preview || file}
                onLoad={() => {
                  URL.revokeObjectURL(file.preview);
                }}
              />
              <div className="img-actions">
                {isReplace && (
                  <div>
                    <input {...getInputProps()} multiple={false} />
                    <BasicIconButton
                      icon={<UploadIcon />}
                      ariaLabel={'remove'}
                      size="small"
                    />
                  </div>
                )}
                {isDelete && (
                  <BasicIconButton
                    className="img-delete"
                    icon={<Delete />}
                    ariaLabel={'remove'}
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onCloseFiles(file?.preview || file);
                      setFiles([]);
                    }}
                  />
                )}
              </div>
            </>
          ))}
        </div>
      </>
    );
  };

  const isActive = isDragAccept || isDragReject;
  return (
    <ImageUploadStyle className="imageUpload">
      <>
        <div className="lebelView">
          <label>
            {label} {required && <span className="requiredSymbol">*</span>}
          </label>
        </div>
        <section
          className={clsx(
            files?.length === 0 && 'upload-hover',
            'uploadImgcontainer',
            isActive && 'dropzone-highlight'
          )}
          {...(() =>
            files?.length > 0 && !isReplace ? {} : { ...getRootProps() })()}
        >
          {files?.length > 0 && !imagepreview ? (
            <div className="prev-parent">{ImagePreviews()}</div>
          ) : (
            <div className="dropzone">
              <input {...getInputProps()} multiple={false} />
              <UploadIcon />
            </div>
          )}
        </section>
      </>
    </ImageUploadStyle>
  );
}
